import React, { useEffect } from 'react';
import HeadingBlock from '../components/common/heading';
import pfp from './../assets/pfp.png'
import Button from '../components/common/button';
import './notifications.css'
import edit from './../../src/assets/eventicon02.svg'
import Navigation from '../components/layout/nav';
import Notification from '../components/common/notification';
const Notifications = () => {
     useEffect(() => {
        const originalColor = window.getComputedStyle(document.body).backgroundColor;
        document.body.style.setProperty('background-color', '#FFF4E2', 'important');
    
        return () => {
          document.body.style.removeProperty('background-color');
          document.body.style.backgroundColor = originalColor;
        };
      }, []);
    return ( <>
    <header className='fixedWidth header2'>
        <HeadingBlock heading="My Notifications" subheading="welcome back, Ahmed" style1="dark left decor"/>
        <div className="btnFlex">
        </div>
        <div className="pfpFlex">
            <img src={pfp} alt="" />
            <div><h6>Ahmed Hassan</h6>
            Costumer
            </div>
        </div>
    </header>
    <section className="notificationsFlex">
        <Notification />
        <Notification />
        <Notification />
        <Notification />
        <Notification />
        <Notification />
        <Notification />

    </section>
    <Navigation />
    </> );
}
 
export default Notifications;